module.exports = __webpack_public_path__ + "static/media/logo-SHOPFROMIZY.aaff3de6.png";